import { Navigate, Route, Routes } from 'react-router-dom';
import { PageTitle } from '../../../_start/layout/core';
import { CreatePartnerPage } from './pages/partner/CreatePartnerPage';
import { PartnersPage } from './pages/partner/PartnersPage';
import { UpdatePartnerPage } from './pages/partner/UpdatePartnerPage';

export const ClientManagementPage = () => {
  return (
    <Routes>
      <Route
        path="partners"
        element={
          <>
            <PageTitle>Partners</PageTitle>
            <PartnersPage />
          </>
        }
      />
      <Route
        path="partners/create"
        element={
          <>
            <PageTitle>Partners</PageTitle>
            <CreatePartnerPage />
          </>
        }
      />
      <Route
        path="partners/:id/update"
        element={
          <>
            <PageTitle>Partners</PageTitle>
            <UpdatePartnerPage />
          </>
        }
      />

      <Route
        index
        element={<Navigate to="/client-management/partners" replace />}
      />
      <Route
        path="*"
        element={<Navigate to="/client-management/partners" replace />}
      />
    </Routes>
  );
};
